<template>
    <base-message v-if="isVisible" :title="`There was an error processing your <span>${userSubscriptionDetails.nickname}</span> payment.`">
       Please review your billing information. Once the payment is processed, your Pro license will automatically be reactivated.
    </base-message>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapState(['currentSubscription']),
        ...mapGetters(['userSubscriptionDetails']),

        /**
         * Retrurn true if subscription status is "Past Due".
         *
         * @returns {boolean} Whether the error is visible.
         */
        isVisible() {
            return this.currentSubscription && 'past_due' === this.currentSubscription.stripe_status;
        },
    },
};
</script>
